// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeCard_container__2MUto","textContainer":"HomeCard_textContainer__DOK9o"};